import React from "react"
import { Container } from "react-bootstrap";
import Spinner from "react-bootstrap/esm/Spinner";
import "./Styles.scss"

const LoadingScreen = (): JSX.Element => {
    return (
        <Container fluid className="verticalAlignment">
            <Container fluid className="horizontalAlignment">
                <Spinner id="LoadingScreen" animation="border" role="status">
                    <span className="visually-hidden" > Loading...</span>
                </Spinner>
            </Container>
        </Container>
    )
}

export default LoadingScreen;